import { requestWithAuth } from './config';

const resource = '/products';

export const getAll = () => {
  return requestWithAuth.get(resource);
};
